export const SEARCH_OPTION_INPUT = {
    searchTextMinLength: 3
};